import {
  CLEAR_PRODUCTS,
  FETCH_PRODUCT,
  FETCH_PRODUCT_FULFILLED,
  FETCH_PRODUCT_REJECTED,
} from 'b2b-apps/shop/product/redux/products/full/actionTypes';
import {
  ClearProductsAction,
  FetchProductAction,
  FetchProductFulfilledAction,
  FetchProductRejectedAction,
  ProductFullType,
} from 'b2b-apps/shop/product/redux/products/full/types';

const clearProducts = (): ClearProductsAction => ({
  type: CLEAR_PRODUCTS,
});

const fetchProduct = (sku: string): FetchProductAction => ({
  type: FETCH_PRODUCT,
  payload: {
    sku,
  },
});

const fetchProductFulfilled = (
  sku: string,
  data: ProductFullType,
): FetchProductFulfilledAction => ({
  type: FETCH_PRODUCT_FULFILLED,
  payload: {
    data,
    sku,
  },
});

const fetchProductRejected = (
  sku: string,
  error: ErrorType,
): FetchProductRejectedAction => ({
  type: FETCH_PRODUCT_REJECTED,
  payload: {
    error,
    sku,
  },
});

export {
  clearProducts,
  fetchProduct,
  fetchProductFulfilled,
  fetchProductRejected,
};
